import type { TranslationTree } from '../../types';

export const backendConfig: TranslationTree = {
  backendConfig: {
    badge: 'Super admin',
    title: 'Backend configuration',
    description: 'External connections that vary per deployment. Changes apply live — no restart.',
    influx: {
      title: 'InfluxDB',
      description:
        'The signals database read by the Signals page, the live predictions and the machine form. The signals worker uses these credentials for read-only queries.',
      savedMessage: 'The signals worker will use this InfluxDB connection on its next request.',
    },
    fields: {
      influxHost: { label: 'Host' },
      influxPort: { label: 'Port' },
      influxUser: { label: 'User' },
      influxPassword: { label: 'Password' },
      influxDatabase: { label: 'Database' },
    },
    save: 'Save changes',
    reset: 'Reset',
    retry: 'Retry',
    saved: 'Configuration saved',
    usingDefaults: {
      title: 'Using deployment defaults',
      body: "No custom configuration is stored yet — the fields above show the values baked into this deployment's .env. Saving creates an override.",
    },
    errors: {
      forbidden: 'You need admin access to change this.',
      generic: 'An error occurred while saving. Please try again.',
      loadFailed: 'Failed to load configuration.',
    },
    loading: 'Loading configuration…',
  },
};
